module.exports = __webpack_public_path__ + "img/dish-3.ae3ea1e4.png";